import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const serviceService = {
  get_all: async (search = "", token) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_ALL}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_all_category: async (token) => {
    const response = await https.get(`${API_ROUTES.SERVICE.GET_ALL_CATEGORY}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  get_list_user_service: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_LIST_USER_SERVICE}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_list_user_service_short: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_LIST_USER_SERVICE_SHORT}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_service_by_category: async (category_id, token) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_ALL_CATEGORY}/${category_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_service_by_id: async (service_id, token) => {
    const response = await https.get(
      `${API_ROUTES.SERVICE.GET_SERVICE_BI_ID}/${service_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
